import { KeyRecoilProps } from '@/shared/model';
import useTabHRSummaryUIEffect from './useTabHRSummaryUIEffect';

/**
 * Keeps the HR summary tab's modal and date-picking state consistent as the user switches tabs, strips and modals, rendering nothing itself.
 *
 * @param keyRecoil - Report store record key identifying which tab's slice of state these effects drive.
 * @returns Null, since this effect-only component renders no markup.
 */
export const TabHRSummaryUIEffect = ({ keyRecoil }: KeyRecoilProps): null => {
  useTabHRSummaryUIEffect({ keyRecoil });
  return null;
};
